export enum PayableAction {
    VIEW = 'View',
    CONFIRM = 'Confirm payable',
    EDIT = 'Edit',
    REMIND_APPROVERS = 'Send reminder to approvers',
    SEND_PAYMENT = 'Send payment',
    PRINT_CHECK = 'Print check',
    VIEW_INVOICE = 'View invoice',
    VIEW_CHECK = 'View check',
    DOWNLOAD = 'Download invoice',
    EXPORT_ATTACHMENTS = 'Export attachments',
    MARK_AS_PAID = 'Mark as paid',
    CANCEL = 'Cancel',
    VOID = 'Void',
    DELETE = 'Delete',
    RETURN_TO_DRAFT = 'Return to draft',
    AUDITS = 'Audits',
    TRACK_MAIL = 'Track mail',
    RESTORE = 'Restore',
    CLEAR_ERRORS = 'Clear errors',
    MARK_AS_PROCESSED = 'Set status as processed',
}
